/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "566")
  

// 接口文档

  
    
export interface IAPI77098ReqInputsItem {
  
  /** 输入code */
  inputCode?: string;
  
  /** 输入内容 */
  inputValue?: string;
  
};
    
  
    
export interface IAPI77098ResInputUserObj {
  
  /** 头像 */
  headImg?: string;
  
  /** 昵称 */
  nickName?: string;
  
  /** 真名 */
  realName?: string;
  
  /** 用户id */
  userId?: string;
  
};
    
  
    
export interface IAPI77098ResOutputUserObj {
  
  /** 头像 */
  headImg?: string;
  
  /** 昵称 */
  nickName?: string;
  
  /** 真名 */
  realName?: string;
  
  /** 用户id */
  userId?: string;
  
};
    
  
    
export type IAPI77098ResExtDataObjDataObj = {};
    
  
    
export interface IAPI77098ResExtDataObj {
  
  /** 数据类型 */
  dataType?: string;
  
  /** 数据 ,Object */
  data?: IAPI77098ResExtDataObjDataObj;
  
};
    
  



export interface API77098Req {
  
  /** 应用code */
  appInstanceCode: string;
  /** sessionCode */
  sessionCode?: string;
  /** 输入信息 ,ChatInputRequest */
  inputs?: IAPI77098ReqInputsItem[];
  /** 用户输入 */
  message?: string;
};



export interface API77098Res {
  /** 主键  */
  id?: number;
  /** 应用实例编码  */
  appInstanceCode?: string;
  /** appCode  */
  appCode?: string;
  /** 会话编号  */
  sessionCode?: string;
  /** 输入用户信息 ,ChatUserResponse  */
  inputUser?: IAPI77098ResInputUserObj;
  /** 输出用户信息 ,ChatUserResponse  */
  outputUser?: IAPI77098ResOutputUserObj;
  /** 输入内容  */
  inputContent?: string;
  /** 输出内容  */
  outputContent?: string;
  /** 输入时间  */
  inputTime?: any;
  /** 输出时间  */
  outputTime?: any;
  /** 扩展信息 ,ExtDataResponse  */
  extData?: IAPI77098ResExtDataObj;
  
};


// 接口函数 77098 app调试

export interface IUsePostAPI77098Return {
  /** app调试: 接口请求状态 */
  isAPI77098Loading: boolean;
  /** app调试: 接口请求返回数据 */
  dataAPI77098: API77098Res;
  /**  app调试: 接口数据请求方法 */
  fetchAPI77098Data: (inputs: API77098Req, config?: YWRequestConfig) => Promise<API77098Res>;
  /** app调试: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI77098 = ():IUsePostAPI77098Return => {
  let isMount = true;
  const [isAPI77098Loading, setIsAPI77098Loading] = useState(false);
  const [dataAPI77098, setDataAPI77098] = useState<API77098Res>({} as API77098Res);
  const requestUrl = `${basePath}/yoaichat-admin/app/debug`;

  const fetchAPI77098Data = async (inputs: API77098Req, config?: YWRequestConfig): Promise<API77098Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API77098Req>) || {}) as API77098Req;
    
  
    if ( isMount ) {
      setIsAPI77098Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API77098Res>(`${basePath}/yoaichat-admin/app/debug`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI77098(res || {} as API77098Res);
        setIsAPI77098Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI77098Loading(false);
      }
      return false as unknown as API77098Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI77098Loading,
    dataAPI77098,
    fetchAPI77098Data,
    requestUrl,
  }
}

